import React from 'react';
import AsyncLoading from '@components/AsyncLoading/AsyncLoading';

const RoleConfigLazy = React.lazy(
	() =>
		import(/* webpackChunkName : 'RoleConfig' */ './components/RolesConfigure')
);

export default (store) => {
	return {
		path: 'roles-configuration',
		element: (
			<AsyncLoading
				component={<RoleConfigLazy permission="CanManageRolesConfig" />}
			/>
		),
	};
};
